import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddCategory({
  open,
  onClose,
  setOpen,
}: AddCategoryModalProps) {
  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Category</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group w_100">
              <label>Image Upload</label>
              <figure className="upload_image no_img  centered">
                <input type="file" />
                <figcaption>
                  <img src="/static/images/user_circle.png" alt="icon" />
                </figcaption>
              </figure>
            </div>
            <div className="control_group">
              <label>Category Name</label>
              <TextField
                placeholder="Enter Category Name"
                fullWidth
                hiddenLabel
              ></TextField>
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
